import React from 'react';
import { Button } from '@mui/material';

function HorasButtonsPeriodo({ recurso, classes, handleData }) {
  const qtdPeriodo = Number(recurso?.qtdPeriodo) || 0;
  return (
    <div style={{ marginLeft: '20px' }}>
      {qtdPeriodo <= 0 ? null : (
        <Button
          color="primary"
          size="sm"
          onClick={() => {
            handleData(qtdPeriodo - 1);
          }}
          className={classes.buttons}
          disabled={recurso && (recurso.validadoCD || recurso.validadoAD || recurso.validadoRH)}
        >
          -
        </Button>
      )}

      <Button
        className={classes.buttons}
        color="primary"
        size="sm"
        onClick={() => {
          handleData(qtdPeriodo + 1);
        }}
        disabled={recurso && (recurso.validadoCD || recurso.validadoAD || recurso.validadoRH)}
      >
        +
      </Button>

      <Button
        className={classes.buttons}
        color="primary"
        size="sm"
        onClick={() => {
          handleData(qtdPeriodo + 4);
        }}
        disabled={recurso && (recurso.validadoCD || recurso.validadoAD || recurso.validadoRH)}
      >
        +4h
      </Button>

      <Button
        className={classes.buttons}
        color="primary"
        size="sm"
        onClick={() => {
          handleData(qtdPeriodo + 8);
        }}
        disabled={recurso && (recurso.validadoCD || recurso.validadoAD || recurso.validadoRH)}
      >
        +8h
      </Button>
    </div>
  );
}

export default HorasButtonsPeriodo;
